import { Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { FaUserPlus } from "react-icons/fa";
import { IoIosClose } from "react-icons/io";
import Header from "../../components/header/index.jsx";
import { Loading } from "../../components/loading";
import formatValues from "../../scripts/formatValues.js";
import AgentMenu from "./components/agentMenu/index.jsx";
import AgentsList from "./components/agentsList/index.jsx";
import CompaniesLinkModal from "./components/companiesLinkModal/index.jsx";
import RegisterDialog from "./components/registerDialog/index.jsx";
import styles from "./css/commissioned.module.css";
import { getCommissionedAgents } from "./services/getCommissionedAgents.js";


export default function Commissioned() {

  const [agents, setAgents] = useState([]);
  const [agentsRender, setAgentsRender] = useState([]);
  const [totalDueThisMonth, setTotalDueThisMonth] = useState(0);

  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  const [showAgentMenu, setShowAgentMenu] = useState(false);
  const [showRegisterDialog, setShowRegisterDialog] = useState(false);
  const [showCompaniesModal, setShowCompaniesModal] = useState(false);

  const selectedAgent = useRef(null);
  const selectedAgentToEdit = useRef(null);



  useEffect(() => {
    const initScreen = async () => {
      try {
        await handleGetAgents();

      } catch (e) {
        console.error('ERROR - INIT SCREEN:', e);

      } finally {
        setLoading(false);
      }
    }

    initScreen();

  }, []);



  const handleGetAgents = async () => {
    try {
      setLoading(true);

      const res = await getCommissionedAgents();

      setAgents(res.agents);
      setAgentsRender(res.agents);
      setTotalDueThisMonth(res.totalDueThisMonth);

    } catch (e) {
      throw e;

    } finally {
      setLoading(false);
    }
  }



  const handleOpenAgent = (agent) => {
    selectedAgent.current = agent;

    setShowAgentMenu(true);
  }



  const handleOpenCompanies = (agent) => {
    selectedAgent.current = agent;

    setShowCompaniesModal(true);
  }



  // CONTROLLER DE MUDANÇA DE VALOR NO INPUT DE BUSCA
  const onChangeSearch = ({ target: { value } }) => {
    setSearch(value.toLowerCase());

    if (value) {
      const array = agents.filter((item) =>
        item.name?.toLowerCase().includes(value.toLowerCase()) ||
        item.email?.toLowerCase().includes(value.toLowerCase()) ||
        item.phone?.toLowerCase().includes(value.toLowerCase())
      );

      setAgentsRender(array);

    } else {
      setAgentsRender(agents);
    }
  }



  const handleReturnFromRegisterDialog = async () => {
    await handleGetAgents();
    selectedAgentToEdit.current = null;
    setShowRegisterDialog(false);
  }



  // SCREEN ====================================>
  return (
    <div>

      <Header>
        <h2 style={{ color: '#fff' }}>Comissionados</h2>

        <div className={styles.searchBar}>
          <input
            className={styles.inputSearchStyle}
            placeholder="Buscar por nome, telefone, email..."
            onChange={onChangeSearch}
            value={search}
          />

          <button
            className={styles.clearSearchButton}
            onClick={() => {
              if (search.length > 0) {
                setSearch('');
                setAgentsRender(agents);
              }
            }}
          >
            <IoIosClose size={22} color={search.length > 0 ? 'red' : 'grey'} />
          </button>
        </div>
      </Header>


      <div className={styles.container}>

        <div className={styles.summaryCard}>
          <span className={styles.summaryCardLabel}>Total a repassar aos comissionados este mês</span>
          <span className={styles.summaryCardValue}>{formatValues(totalDueThisMonth)}</span>
        </div>

        <div className={styles.toolbarArea}>
          <Button
            variant="contained"
            startIcon={<FaUserPlus />}
            onClick={() => {
              selectedAgentToEdit.current = null;
              setShowRegisterDialog(true);
            }}
            sx={{
              backgroundColor: "var(--color-primary-background)",
              "&:hover": { backgroundColor: "var(--color-secondary-background)" },
            }}
          >
            Novo comissionado
          </Button>
        </div>

        <div className={styles.contentArea}>

          {loading ? (
            <Loading />

          ) : agents.length > 0 ? (
            <>
              {agentsRender.length === 0 ? (
                <p className={styles.noDataText}>Nenhum comissionado foi encontrado para a busca realizada.</p>

              ) : (
                <AgentsList
                  agents={agentsRender}
                  openAgent={(agent) => handleOpenAgent(agent)}
                  openCompanies={(agent) => handleOpenCompanies(agent)}
                />
              )}
            </>

          ) : (
            <p className={styles.noDataText}>Nenhum comissionado cadastrado até o momento.</p>
          )}

        </div>
      </div>



      {/* <=============== COMPONENTS CONTROL ===============> */}

      <AgentMenu
        view={showAgentMenu}
        data={selectedAgent.current}
        openEditor={() => {
          selectedAgentToEdit.current = selectedAgent.current;
          setShowRegisterDialog(true);
        }}
        openCompaniesModal={() => setShowCompaniesModal(true)}
        close={() => setShowAgentMenu(false)}
      />

      <RegisterDialog
        view={showRegisterDialog}
        onClose={() => {
          selectedAgentToEdit.current = null;
          setShowRegisterDialog(false);
        }}
        onReturn={() => handleReturnFromRegisterDialog()}
        agent={selectedAgentToEdit.current}
      />

      <CompaniesLinkModal
        show={showCompaniesModal}
        agent={selectedAgent.current}
        onClose={() => setShowCompaniesModal(false)}
        onDataChanged={() => handleGetAgents()}
      />

    </div>
  );
}
